/**
 * Detect programming language from file extension
 * @param fileName - File name with extension
 * @returns Language name for syntax highlighter
 */
export const detectLanguageFromFileName = (fileName: string): string => {
    const ext = fileName.split('.').pop()?.toLowerCase() || '';

    const languageMap: Record<string, string> = {
        // JavaScript/TypeScript
        js: 'javascript',
        jsx: 'jsx',
        ts: 'typescript',
        tsx: 'tsx',
        mjs: 'javascript',
        cjs: 'javascript',

        // Web
        html: 'html',
        htm: 'html',
        css: 'css',
        scss: 'scss',
        sass: 'sass',
        less: 'less',

        // JSON/Config
        json: 'json',
        jsonc: 'json',
        json5: 'json',
        yaml: 'yaml',
        yml: 'yaml',
        toml: 'toml',
        xml: 'xml',
        svg: 'xml',

        // Python
        py: 'python',
        pyw: 'python',
        pyx: 'python',

        // Java/Kotlin
        java: 'java',
        kt: 'kotlin',
        kts: 'kotlin',

        // C/C++
        c: 'c',
        h: 'c',
        cpp: 'cpp',
        cc: 'cpp',
        cxx: 'cpp',
        hpp: 'cpp',

        // C#
        cs: 'csharp',

        // Go
        go: 'go',

        // Rust
        rs: 'rust',

        // PHP
        php: 'php',

        // Ruby
        rb: 'ruby',
        erb: 'erb',

        // Shell
        sh: 'bash',
        bash: 'bash',
        zsh: 'bash',
        fish: 'bash',

        // SQL
        sql: 'sql',

        // Markdown
        md: 'markdown',
        mdx: 'markdown',

        // Docker
        dockerfile: 'dockerfile',

        // GraphQL
        graphql: 'graphql',
        gql: 'graphql',

        // Others
        diff: 'diff',
        patch: 'diff',
        txt: 'text',
        log: 'log',
    };

    // Special cases for files without extensions or specific names
    const fileNameLower = fileName.toLowerCase();
    if (fileNameLower === 'dockerfile' || fileNameLower.startsWith('dockerfile.')) {
        return 'dockerfile';
    }
    if (fileNameLower === 'makefile' || fileNameLower === 'makefile.am') {
        return 'makefile';
    }
    if (fileNameLower === '.gitignore' || fileNameLower === '.dockerignore') {
        return 'text';
    }
    if (fileNameLower.startsWith('.env')) {
        return 'bash';
    }

    return languageMap[ext] || 'text';
};
